import {
  API_RESPONSE_ERROR,
  API_RESPONSE_SUCCESS,
  CANCEL_PROPOSAL,
  CHANGE_STATUS,
  REACTIVE_PROPOSAL,
  CHECK_CPF_PROPOSAL,
  CREATE_PROPOSAL,
  DELETE_PROPOSAL,
  GET_PROPOSAL,
  GET_PROPOSAL_ASSOCIATES,
  GET_PROPOSAL_BY_ID,
  UPDATE_PROPOSAL,
} from './actionType';

// common success
export const ProposalApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const ProposalApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Proposal = () => ({
  type: GET_PROPOSAL,
});

export const GetProposalById = (cpf_cnpj) => ({
  type: GET_PROPOSAL_BY_ID,
  payload: { cpf_cnpj },
});

export const CreateProposal = (data, history) => ({
  type: CREATE_PROPOSAL,
  payload: { data, history },
});

export const UpdateProposal = (id, data, history) => ({
  type: UPDATE_PROPOSAL,
  payload: { id, data, history },
});

export const DeleteProposal = (id) => ({
  type: DELETE_PROPOSAL,
  payload: { id },
});

export const CheckCpfProposal = (data) => ({
  type: CHECK_CPF_PROPOSAL,
  payload: data,
});

export const ProposalGetAssociates = (data) => ({
  type: GET_PROPOSAL_ASSOCIATES,
  payload: data,
});

export const CancelProposal = (data) => ({
  type: CANCEL_PROPOSAL,
  payload: { data },
});

export const ChangeStatus = (data) => ({
  type: CHANGE_STATUS,
  payload: data,
});

export const ReactiveProposal = (data) => ({
  type: REACTIVE_PROPOSAL,
  payload: data,
});
